import React, { Component } from "react";
import {Link} from 'react-router-dom'

export default class TopicDetail extends Component {
  state = {
    class: [
      {
        name: "Math",
        teacher: "James stunner",
        time: "",
        image:
          "https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      },
      {
        name: "Chemistry",
        teacher: "Gary smith",
        time: "",
        image: "http://steezo.com/wp-content/uploads/2012/12/man-in-suit2.jpg"
      },
      {
        name: "Biology",
        teacher: "Luis james",
        time: "",
        image:
          "https://media.istockphoto.com/photos/happy-laughing-man-picture-id544358212?k=6&m=544358212&s=612x612&w=0&h=odURMNz2hty8LIfpVahaaUKpGU4vd-UlZx4jy-OAnJA="
      }
    ],
    upcomingClass: [
      {
        name: "Biology",
        teacher: "Luis james",
        time: "10 AM",
        duration :"30 min",
        image:
          "https://media.istockphoto.com/photos/happy-laughing-man-picture-id544358212?k=6&m=544358212&s=612x612&w=0&h=odURMNz2hty8LIfpVahaaUKpGU4vd-UlZx4jy-OAnJA="
      },
      {
        name: "Technology",
        teacher: "Chris steve",
        time: "11 AM",
                duration :"45 min",
        image:
          "https://image.shutterstock.com/image-photo/close-portrait-smiling-handsome-man-260nw-1011569245.jpg"
      }
    ]
  };
  render() {
    return (
      <div>
        <div className="row shadow-sm m-0">
          <div className="col-md-6 p-0">
            <img
              className="card-img-top course-detail-image"
              src="https://images.pexels.com/photos/163032/office-pen-calculator-computation-163032.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            />
          </div>
          <div className="col-md-6 bg-white d-flex justify-content-center align-items-center">
            <div className="p-4">
              <h4>Algebra</h4>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged
              </p>
            </div>
          </div>
        </div>
        <div class="container py-5">
          <div class="row">
            <div class="col-md-12">
              <div class="">
                <div class="">
                  <ul class="nav nav-tabs ">
                    <li>
                      <a
                        href="#tab_default_1"
                        data-toggle="tab"
                        className="link-unstyled tab-link shadow-sm active"
                      >
                        <i class="fas fa-chalkboard mr-1"></i> Live Classes
                      </a>
                    </li>
                    <li>
                      <a
                        href="#tab_default_2"
                        data-toggle="tab"
                        className="link-unstyled tab-link shadow-sm"
                      >
                        <i class="fas fa-forward mr-1"></i> Upcoming Classes
                      </a>
                    </li>
                    <li>
                      <a
                        href="#tab_default_3"
                        data-toggle="tab"
                        className="link-unstyled tab-link shadow-sm"
                      >
                        <i class="fas fa-video mr-1"></i> Recorded Classes
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="tab_default_1">
                      <div className="row">
                        {this.state.class.map(course => {
                          return (
                            <div className="col-md-3 my-3">
                              <div
                                className="card card-selector shadow-sm"
                                onClick={this.cardSelect}
                              >
                                <div className="d-flex align-items-center justify-content-center">
                                  <img
                                    class="image-cover"
                                    src={course.image}
                                    alt="Card image"
                                  />
                                </div>
                                <div class="card-body pt-0 text-center">
                                  <h5 className="mb-0">{course.name}</h5>
                                 <div className="blockquote-footer m-0">
                                    By {course.teacher}
                                  </div>

                                  <p class="card-text pt-2">
                                    Some example text.
                                  </p>
                                  <Link to="/join" class="btn btn-primary">
                                    Join
                                  </Link>
                                </div>
                                <div className="class-price">&#8377;100</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div class="tab-pane" id="tab_default_2">
                      <div className="row">
                        {this.state.upcomingClass.map(course => {
                          return (
                            <div className="col-md-3 my-3">
                              <div
                                className="card card-selector shadow-sm"
                                onClick={this.cardSelect}
                              >
                                <div className="d-flex align-items-center justify-content-center">
                                  <img
                                    class="image-cover"
                                    src={course.image}
                                    alt="Card image"
                                  />
                                </div>
                                <div class="card-body pt-0 text-center">
                                  <h5 className="mb-0">{course.name}</h5>
                                 <div className="blockquote-footer m-0">
                                    By {course.teacher}
                                  </div>

                                  <p class="card-text pt-2 m-0">Today</p>
                                  <p class="card-text">
                                    {course.time} - {course.duration}
                                  </p>
                                  <Link to="/join" class="btn btn-primary">
                                    Book
                                  </Link>
                                </div>
                                <div className="class-price">&#8377;100</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div class="tab-pane" id="tab_default_3">
                      <div className="row">
                        {this.state.class.map(course => {
                          return (
                            <div className="col-md-3 my-3">
                              <div
                                className="card card-selector shadow-sm"
                                onClick={this.cardSelect}
                              >
                                <div className="d-flex align-items-center justify-content-center">
                                  <img
                                    class="image-cover"
                                    src={course.image}
                                    alt="Card image"
                                  />
                                </div>
                                <div class="card-body pt-0 text-center">
                                  <h5 className="mb-0">{course.name}</h5>
                                 <div className="blockquote-footer m-0">
                                    By {course.teacher}
                                  </div>

                                  <p class="card-text pt-2">
                                    Some example text.
                                  </p>
                                  <Link to="/join" class="btn btn-primary">
                                    Join
                                  </Link>
                                </div>
                                <div className="class-price">&#8377;100</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
